import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ExistingOptionI18n_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	optionID: string;
	langCode: LangCode;
};

export const useOptionI18nEditQuery = ({ hotelID, optionID, langCode }: Props) => {
	const { data } = useCustomSuspenseQuery(ExistingOptionI18n_EditPage_Query, {
		variables: { hotelID, optionID, lang: langCode },
	});

	return data;
};
